export type ElementType = 'signature' | 'text' | 'stamp' | 'date';
export type SignatureAssetType = 'signature' | 'stamp' | 'initials';

export interface PDFElement {
  id: string;
  type: ElementType;
  x: number;
  y: number;
  width: number;
  height: number;
  page: number;
  content: string; // base64 for images, text content for text/date
  style?: TextStyle;
}

export interface TextStyle {
  fontFamily: 'Dancing Script' | 'Great Vibes' | 'Satisfy' | 'sans-serif' | 'serif';
  fontSize: number;
  color: string;
  isBold?: boolean;
  isItalic?: boolean;
  dateFormat?: DateFormat;
}

export interface SavedSignature {
  id: string;
  type: SignatureAssetType;
  name: string;
  url: string;
  filePath: string;
  isDefault: boolean;
  createdAt: string;
}

export const DEFAULT_ELEMENT_SIZES: Record<ElementType, { width: number; height: number }> = {
  signature: { width: 200, height: 80 },
  stamp: { width: 120, height: 120 },
  text: { width: 200, height: 40 },
  date: { width: 140, height: 30 },
};

export const CURSIVE_FONTS = [
  { value: 'Dancing Script', label: 'Dancing Script' },
  { value: 'Great Vibes', label: 'Great Vibes' },
  { value: 'Satisfy', label: 'Satisfy' },
  { value: 'sans-serif', label: 'Sans Serif' },
  { value: 'serif', label: 'Serif' },
] as const;

export const DEFAULT_TEXT_STYLE: TextStyle = {
  fontFamily: 'Dancing Script',
  fontSize: 24,
  color: '#1a1a2e',
};

export type DateFormat = 'dd/MM/yyyy' | 'd MMMM yyyy' | 'yyyy-MM-dd';

export const DATE_FORMATS: { value: DateFormat; label: string; example: string }[] = [
  { value: 'dd/MM/yyyy', label: 'JJ/MM/AAAA', example: '06/01/2026' },
  { value: 'd MMMM yyyy', label: 'Jour Mois Année', example: '6 janvier 2026' },
  { value: 'yyyy-MM-dd', label: 'AAAA-MM-JJ', example: '2026-01-06' },
];

export const formatDateWithFormat = (date: Date, format: DateFormat): string => {
  const day = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear();
  
  const months = [
    'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
    'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'
  ];
  
  switch (format) {
    case 'dd/MM/yyyy':
      return `${day.toString().padStart(2, '0')}/${(month + 1).toString().padStart(2, '0')}/${year}`;
    case 'd MMMM yyyy':
      return `${day} ${months[month]} ${year}`;
    case 'yyyy-MM-dd':
      return `${year}-${(month + 1).toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
    default:
      return `${day.toString().padStart(2, '0')}/${(month + 1).toString().padStart(2, '0')}/${year}`;
  }
};
